<template>
  <div class="my-12 md:my-16 lg:my-20">
    <ul v-if="type === 'inline'" class="max-w-6xl mx-auto">
      <li v-for="img in row.files" :key="img.src">
        <media-item :item="img" :block="blockCaption" @img-select="focus($event)" class="w-full mx-auto inline-block max-w-full"/>
      </li>

      <!-- block caption -->
      <figcaption v-if="blockCaption" v-html="blockCaption" class="max-w-6xl mx-auto text-xs mt-2 mb-6 flex-1 mb-16"></figcaption>
    </ul>

    <div v-else-if="type === 'slideshow'" class="w-full">
      <div ref="slider" class="w-full">
        <figure v-for="img in images" :key="img.src" class="mx-2 md:mx-3" :data-src="img.src">
          <img :src="blank" :data-src="lgImg(img)" class="slideshow-img lazyload"/>
          <figcaption v-if="img.content && !blockCaption" v-html="img.content.caption" class="text-xs mt-2 flex-1 md:text-left leading-tight max-w-caption"></figcaption>
        </figure>
      </div>

      <div class="max-w-6xl mx-auto text-xs mt-2 mb-6 flex-1">
        <div>
          <a @click="flkty.previous()" class="cursor-pointer text-2xl pr-4 hover:text-orange-brand">&larr;</a>
          <a @click="flkty.next()" class="cursor-pointer text-2xl px-4 hover:text-orange-brand">&rarr;</a>
        </div>

        <!-- block caption -->
        <figcaption v-if="blockCaption" v-html="blockCaption" ></figcaption>
      </div>
    </div>

    <div v-else-if="type === 'grid'" class="my-8 lg:my-16">
      <div>
        <ul class="flex flex-wrap -mx-2">
          <li v-for="img in row.files" :key="img.src" @click="focus(img.src)" class="px-2 mb-4 w-1/2 lg:w-1/3 cursor-zoom-in">
            <base-bg-image :image="img" :cover="false"/>
          </li>
        </ul>
      </div>

      <!-- block caption -->
      <figcaption v-if="blockCaption" v-html="blockCaption" class="max-w-6xl mx-auto text-xs mt-2 mb-6 flex-1"></figcaption>
    </div>
  </div>
</template>

<script>
import { lgImg } from '@/utils'
import MediaItem from '@/components/MediaItem'
import Flickity from 'flickity'
require('flickity-imagesloaded')

export default {
  name: 'BaseArticleImagesRow',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      changingImg: false,
      flkty: null,
      lightboxVisible: false,
      lightboxIndex: 0,
      slideshowCheck: null
    }
  },
  computed: {
    type () {
      return this.row.display_type || 'inline'
    },
    images () {
      if (!this.row.files) return []
      return this.row.files.filter((i) => i.type === 'image')
    },
    imgCount () {
      return this.images.length
    },
    blockCaption () {
      const c = this.row.caption
      if (!c) return false
      return c.length > 0 && c
    }
  },
  mounted () {
    const el = this.$refs.slider
    if (!el) return

    this.$nextTick(() => {
      this.flkty = new Flickity(el, {
        // imagesloaded does exactly nothing :(
        // see below for loaded hook
        imagesLoaded: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left'
      })

      this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        this.focus(cellElement.getAttribute('data-src'))
      })

      this.slideshowCheck = window.setInterval(() => {
        this.flkty && this.flkty.resize()
      }, 1000)
    })
  },
  beforeDestroy () {
    clearInterval(this.slideshowCheck)
  },
  methods: {
    lgImg,

    showLightbox (i) {
      this.lightboxIndex = i
      this.lightboxVisible = true
    },
    maxWidth (img) {
      if (!img || !img.dimensions) return
      const w = Math.min(window.innerWidth - 32, img.dimensions.width)
      return { maxWidth: `${w}px` }
    },
    width ({ dimensions }) {
      return dimensions.width
    },
    height ({ dimensions }) {
      return dimensions.height
    },
    focus (img = null) {
      this.$emit('img-select', img)
    },
    imgLoaded () {
      // TODO: Why does it not work without this delay
      // window.setTimeout(() => {
      //   this.flkty && this.flkty.resize()
      // }, 300)
    }
  },
  components: { MediaItem }
}
</script>
